import productGallery from './single-product/product-gallery';
import relatedFlavors from './single-product/related-flavors';
import destiniWtb from './single-product/destini-wtb';
productGallery;
relatedFlavors;
destiniWtb;
window.addEventListener('DOMContentLoaded', function () {
  /* TABS */

  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  if (0 < tabBtns.length) {
    // display first tab on init
    let firstTabID = tabBtns[0].getAttribute('data-tab');
    tabBtns[0].classList.add('active');
    document.getElementById(firstTabID).classList.add('opened');

    // change on click
    tabBtns.forEach(function (tabBtn) {
      tabBtn.addEventListener('click', function () {
        let tabID = tabBtn.getAttribute('data-tab');
        tabContents.forEach((tabContent) =>
          tabContent.classList.remove('opened')
        );
        tabBtns.forEach((btn) => btn.classList.remove('active'));
        document.getElementById(tabID).classList.add('opened');
        tabBtn.classList.add('active');
      });
    });
  }

  /* FIN TABS */

  /* SUPPLIERS POPUP */

  const suppliersBtn = document.querySelector('.suppliers-popup-btn');
  const suppliersCloseBtn = document.getElementById('suppliers-popup-close');
  const suppliersPopup = document.getElementById('suppliers-popup');

  if (suppliersPopup) {
    suppliersBtn.addEventListener('click', function () {
      suppliersPopup.classList.add('opened');
      suppliersBtn.setAttribute('aria-expanded', true);
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
    });

    suppliersCloseBtn.addEventListener('click', function () {
      suppliersPopup.classList.remove('opened');
      suppliersBtn.setAttribute('aria-expanded', false);
      document.body.style.overflow = 'visible';
      document.body.style.height = 'auto';
    });
  }

  /* FIN SUPPLIERS POPUP */
});
